import { render, staticRenderFns } from "./DamageReportDetail.vue?vue&type=template&id=52ec8940&scoped=true&"
import script from "./DamageReportDetail.vue?vue&type=script&lang=js&"
export * from "./DamageReportDetail.vue?vue&type=script&lang=js&"
import style0 from "./DamageReportDetail.vue?vue&type=style&index=0&id=52ec8940&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ec8940",
  null
  
)

export default component.exports